import React, { Component } from 'react';
import {
  Input,
  Row, Col,
  Label, FormGroup, Table,
  Card, CardBody
} from 'reactstrap';
import Validation from '../../services/Validation';
import FleetService from '../../services/FleetService';
import lodash from 'lodash';
import ModalService from '../../services/ModalService';
import CustomSpinner from '../CustomSpinner/CustomSpinner';

const defaultTyreObj = {
  vehicle_type_id: '',
  fleet_id: '',
  temp_id: '',
  vehicle_type: {
    value: '',
    valid: true,
    touched: false,
    nullValue: null,
    showErrorMsg: false
  },
  construction: {
    value: '',
    valid: null,
    touched: false,
    nullValue: null,
    showErrorMsg: false
  },
  size: {
    value: '',
    valid: null,
    touched: false,
    nullValue: null,
    showErrorMsg: false
  },
  brand: {
    value: '',
    valid: null,
    touched: false,
    nullValue: null,
    showErrorMsg: false
  },
  brand_id: {
    value: '',
    valid: null,
    touched: false,
    nullValue: null,
    showErrorMsg: false
  },
  pattren: {
    value: '',
    valid: null,
    touched: false,
    nullValue: null,
    showErrorMsg: false
  },
  tyres: {
    value: '',
    valid: null,
    touched: false,
    nullValue: null,
    showErrorMsg: false
  },
  type: {
    value: '',
    valid: null,
    touched: false,
    nullValue: null,
    showErrorMsg: false
  },
  pattern: [],
  brands: []
}
const default_bias_radial_tyres = {
  bias_potential_average_per_month: 0,
  radial_potential_average_per_month: 0,
  no_of_tube_tyre: 0,
  no_of_tubeless_tyre: 0,
}
class VehicleDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vehicleData: {},
      vehicles: {},
      all_vehicle_total_tyre_year_truck: '',
      all_vehicle_total_tyre_year_bus: '',
      invalidCountError: {
        truck: {
          message: '',
          isInValid: false
        },
        bus: {
          message: '',
          isInValid: false
        },
        lcv: {
          message: '',
          isInValid: false
        },
        scv: {
          message: '',
          isInValid: false
        },
        icv: {
          message: '',
          isInValid: false
        },
        pickup: {
          message: '',
          isInValid: false
        }
      },
      controls: {
        frontRearData: {
          truck: [],
          bus: [],
          lcv: [],
          scv: [],
          icv: [],
          pickup: []
        },
        bias_radial_tyres: {
          truck: JSON.parse(JSON.stringify(default_bias_radial_tyres)),
          bus: JSON.parse(JSON.stringify(default_bias_radial_tyres)),
          scv: JSON.parse(JSON.stringify(default_bias_radial_tyres)),
          lcv: JSON.parse(JSON.stringify(default_bias_radial_tyres)),
          icv: JSON.parse(JSON.stringify(default_bias_radial_tyres)),
          pickup: JSON.parse(JSON.stringify(default_bias_radial_tyres)),
        }
      }
    }
    this.state.tbrTyreSize = ["7.50R20", "8.25R20", "9.00R20", "10.00R20",
      "11.00R20", "12.00R20", "11R22.5", "255/70R22.5", "275/80R22.5", "295/80R22.5", "315/80R22.5"];

    this.state.tbbTyreSize = ["7.50-20", "8.25-20", "9.00-20",
      "10.00-20", "11.00-20", "12.00-20", "295/95D20"];

    this.state.tbbLcvScv = ["7.00-15", "7.00-16", "7.50-15", "7.50-16", "8.25-15", "8.25-16",
      "155/80D12", "195/80D15"];

    this.state.tbrLcvScv = ["7.00R15", "7.00R16", "7.50R16", "8.25R16", "195/80R15", "215/75R15",
      "215/75R16", "215R14", "225/75R16", "235/75R17.5"];
  }

  setFrontRearData = (data) => {
    let { controls } = this.state;
    let { frontRearData, bias_radial_tyres } = controls;

    data.forEach((element) => {
      if (element.business_related_detail.length > 0) {
        let isNewData = frontRearData[element.type_name].length === 0 ? true : false;
        element.business_related_detail.forEach((element_detail, i) => {
          if (isNewData) {
            frontRearData[element.type_name].push(JSON.parse(JSON.stringify(defaultTyreObj)));
            frontRearData[element.type_name][i].vehicle_type_id = element.vehicle_type_id;
            frontRearData[element.type_name][i].temp_id = element.temp_id ? element.temp_id : '';
            frontRearData[element.type_name][i].fleet_id = element.fleet_id;
            frontRearData[element.type_name][i].construction.value = element_detail.construction ? element_detail.construction : '';
            frontRearData[element.type_name][i].size.value = element_detail.size ? element_detail.size : '';
            frontRearData[element.type_name][i].brand.value = element_detail.brand ? element_detail.brand : '';
            frontRearData[element.type_name][i].tyres.value = element_detail.tyres ? element.tyres : '';
            frontRearData[element.type_name][i].type.value = element_detail.type ? element_detail.type : '';
            if (element_detail.brand_id) {
              frontRearData[element.type_name][i].brand_id.value = element_detail.brand_id ? element_detail.brand_id : '';
              this.changeFrontBrand(element_detail.construction, element_detail.brand, i, element.type_name);
            } if (element_detail.construction) {
              this.getBrand(element_detail.construction, i, element.type_name, true);
            }
            frontRearData[element.type_name][i].pattren.value = element_detail.pattren ? element_detail.pattren : '';
            frontRearData[element.type_name][i].tyres.value = element_detail.tyres ? element_detail.tyres : '';
          }
        });
      } else {
        if (frontRearData[element.type_name]) {
          if (frontRearData[element.type_name].length <= 0) {
            frontRearData[element.type_name].push(JSON.parse(JSON.stringify(defaultTyreObj)));
            frontRearData[element.type_name][0].vehicle_type_id = element.vehicle_type_id;
            frontRearData[element.type_name][0].temp_id = element.temp_id ? element.temp_id : '';
            frontRearData[element.type_name][0].fleet_id = element.fleet_id;
          }
        }
      }
    });

    data.forEach((element) => {

      if (element.bias_radial_count) {
        if (element.type_name !== 'truck' && element.type_name !== 'bus') {
          bias_radial_tyres[element.type_name].bias_potential_average_per_month = element.bias_radial_count.bias_potential_average_per_month ? element.bias_radial_count.bias_potential_average_per_month : 0;
          bias_radial_tyres[element.type_name].radial_potential_average_per_month = element.bias_radial_count.radial_potential_average_per_month ? element.bias_radial_count.radial_potential_average_per_month : 0;
          bias_radial_tyres[element.type_name].no_of_tube_tyre = element.bias_radial_count.no_of_tube_tyre ? element.bias_radial_count.no_of_tube_tyre : 0;
          bias_radial_tyres[element.type_name].no_of_tubeless_tyre = element.bias_radial_count.no_of_tubeless_tyre ? element.bias_radial_count.no_of_tubeless_tyre : 0;
        } else {

          if (!bias_radial_tyres[element.type_name].bias_potential_average_per_month) {
            bias_radial_tyres[element.type_name].bias_potential_average_per_month = element.bias_radial_count.bias_potential_average_per_month ? element.bias_radial_count.bias_potential_average_per_month : 0;
          }
          if (!bias_radial_tyres[element.type_name].radial_potential_average_per_month) {
            bias_radial_tyres[element.type_name].radial_potential_average_per_month = element.bias_radial_count.radial_potential_average_per_month ? element.bias_radial_count.radial_potential_average_per_month : 0;
          }
          if (!bias_radial_tyres[element.type_name].no_of_tube_tyre) {
            bias_radial_tyres[element.type_name].no_of_tube_tyre = element.bias_radial_count.no_of_tube_tyre ? element.bias_radial_count.no_of_tube_tyre : 0;
          }
          if (!bias_radial_tyres[element.type_name].no_of_tubeless_tyre) {
            bias_radial_tyres[element.type_name].no_of_tubeless_tyre = element.bias_radial_count.no_of_tubeless_tyre ? element.bias_radial_count.no_of_tubeless_tyre : 0;
          }
        }
      }
    });


    this.setState({
      controls
    }, () => {
      // if (frontRearData['truck'].length > 0) {
      //   this.changeBiasRadialCount('truck');
      // }
      // if (frontRearData['bus'].length > 0) {
      //   this.changeBiasRadialCount('bus');
      // }
      // if (frontRearData['lcv'].length > 0) {
      //   this.changeBiasRadialCount('lcv');
      // }
      // if (frontRearData['icv'].length > 0) {
      //   this.changeBiasRadialCount('icv');
      // }
      // if (frontRearData['scv'].length > 0) {
      //   this.changeBiasRadialCount('scv');
      // }
      // if (frontRearData['pickup'].length > 0) {
      //   this.changeBiasRadialCount('pickup');
      // }
    })
  }

  deletBiasRadial = (key) => {
    let { controls, invalidCountError } = this.state;

    if (key === 'bus') {
      invalidCountError.bus.isInValid = false;
    }
    if (key === 'truck') {
      invalidCountError.truck.isInValid = false;
    }
    if (key === 'lcv') {
      invalidCountError.lcv.isInValid = false;
    }
    if (key === 'scv') {
      invalidCountError.scv.isInValid = false;
    }
    if (key === 'icv') {
      invalidCountError.icv.isInValid = false;
    }
    if (key === 'pickup') {
      invalidCountError.pickup.isInValid = false;
    }
    controls.bias_radial_tyres[key] = {};
    let { frontRearData } = controls;
    frontRearData[key] = [];
    this.setState({
      controls,
      frontRearData,
      invalidCountError
    })
  }

  inValidCountVehicleDetailError = (obj) => {
    let { invalidCountError } = this.state;
    invalidCountError.truck.isInValid = false;
    invalidCountError.bus.isInValid = false;
    invalidCountError.lcv.isInValid = false;
    invalidCountError.scv.isInValid = false;
    invalidCountError.icv.isInValid = false;
    invalidCountError.pickup.isInValid = false;
    if (obj.truck.isInValid) {
      invalidCountError.truck = obj.truck;
    } else if (obj.scv.isInValid) {
      invalidCountError.scv = obj.scv;
    } else if (obj.lcv.isInValid) {
      invalidCountError.lcv = obj.lcv;
    } else if (obj.icv.isInValid) {
      invalidCountError.icv = obj.icv;
    } else if (obj.bus.isInValid) {
      invalidCountError.bus = obj.bus;
    } else if (obj.pickup.isInValid) {
      invalidCountError.pickup = obj.pickup;
    }

    this.setState({
      invalidCountError
    })
  }

  setData = (data) => {

    let vehicleData = Object.assign({}, data);
    // if (Object.keys(vehicleData).length <= 0) {
    //   this.setState({
    //     vehicleData: {}
    //   })
    //   return;
    // }
    let { controls } = this.state;
    let { frontRearData
      // , rearData 
    } = controls;
    // if (vehicleData.totalCountTruck > 0) {
    //   if (frontRearData.truck.length === 0) {
    //     frontRearData.truck.push(JSON.parse(JSON.stringify(defaultTyreObj)));
    //   }
    // } else {
    //   frontRearData['truk'] = [];
    // }
    // if (vehicleData.totalCountBus > 0) {
    //   if (frontRearData.bus.length === 0) {
    //     frontRearData.bus.push(JSON.parse(JSON.stringify(defaultTyreObj)));
    //   }
    // } else {
    //   frontRearData['bus'] = [];
    // }
    // if (vehicleData.totalCountLcv > 0) {
    //   if (frontRearData.lcv.length === 0) {
    //     frontRearData.lcv.push(JSON.parse(JSON.stringify(defaultTyreObj)));
    //   }
    // } else {
    //   frontRearData['lcv'] = [];
    // }
    // if (vehicleData.totalCountScv > 0) {
    //   if (frontRearData.scv.length === 0) {
    //     frontRearData.scv.push(JSON.parse(JSON.stringify(defaultTyreObj)));
    //   }
    // } else {
    //   frontRearData['scv'] = [];
    // }

    // if (vehicleData.totalCountIcv > 0) {
    //   if (frontRearData.icv.length === 0) {
    //     frontRearData.icv.push(JSON.parse(JSON.stringify(defaultTyreObj)));
    //   }
    // } else {
    //   frontRearData['icv'] = [];
    // }
    // if (vehicleData.totalCountPickup > 0) {
    //   if (frontRearData.pickup.length === 0) {
    //     frontRearData.pickup.push(JSON.parse(JSON.stringify(defaultTyreObj)));
    //   }
    // } else {
    //   frontRearData['pickup'] = [];
    // }
    this.setState({
      vehicleData: vehicleData,
      frontRearData
    })
  }

  addFrontTyreObject = (key) => {
    const { controls } = this.state;
    const { frontRearData } = controls;
    frontRearData[key].push(JSON.parse(JSON.stringify(defaultTyreObj)));
    frontRearData[key][frontRearData[key].length - 1].vehicle_type_id = frontRearData[key][frontRearData[[key]].length - 2].vehicle_type_id;
    frontRearData[key][frontRearData[key].length - 1].temp_id = frontRearData[key][frontRearData[key].length - 2].temp_id ? frontRearData[key][frontRearData[key].length - 2].temp_id : '';
    frontRearData[key][frontRearData[key].length - 1].fleet_id = frontRearData[key][frontRearData[key].length - 2].fleet_id;
    this.setState({ controls });
  }

  removeFrontTyre = (index, key) => {
    const { controls } = this.state;
    const { frontRearData } = controls;
    if (frontRearData[key].length === 1) {
      ModalService.openAlert('', `Sorry, ${key} tyres related details are mandatory.`, 'error');
      return;
    } else {
      frontRearData[key].splice(index, 1);
      if (key === 'truck' || key === 'bus') {
        this.changeBiasRadialCount(key, index);
      }
    }
    this.setState({ controls });
  }

  onChangeFrontTyre = (e, index, key, brands = []) => {
    const controlName = e.target.name;
    const controlValue = e.target.value;
    const { controls } = this.state;
    const { frontRearData } = controls;
    if (controlName === 'tyres') {
      if (isNaN(controlValue)) {
        return
      }
      if (controlValue === 0 || controlValue === '0') {
        return
      }
    }
    const tyreObj = frontRearData[key][index];
    tyreObj[controlName].value = controlValue;
    tyreObj[controlName].touched = true;
    tyreObj.vehicle_type.value = key;
    if (controlName === 'construction') {
      tyreObj.size.value = '';
      tyreObj.brand.value = '';
      tyreObj.pattren.value = '';
      this.getBrand(controlValue, index, key, true);
    } else if (controlName === 'brand') {
      tyreObj.pattren.value = '';
      if (tyreObj.brand.value) {
        this.changeFrontBrand(tyreObj.construction.value, tyreObj.brand.value, index, key);
      }

      let brand = lodash.filter(brands, (element) => {
        return element.name.toLowerCase() === tyreObj.brand.value;
      });
      if (brand.length > 0) {
        tyreObj.brand_id.value = brand[0].id;
      } else {
        tyreObj.brand_id.value = 'other';
      }
    }
    this.setState({
      controls
    }, () => {
      if (key === 'truck' || key === 'bus') {
        this.changeBiasRadialCount(key, index, tyreObj);
      }
    });
    this.handleValidationFrontData(key);
  }

  changeBiasRadialCount = (key) => {
    const { controls } = this.state;
    const { frontRearData, bias_radial_tyres } = controls;
    let tyreObj = frontRearData[key];
    let tube_tyre = 0, tubeless_tyre = 0, total_tyre = 0, radial_tyre = 0, bias_tyre = 0;
    let radialTyres = ['11R22.5', '255/70R22.5', '275/80R22.5', '295/80R22.5', '315/80R22.5'];
    tyreObj.forEach(element => {
      let isRadialtyre = false;
      if (element.size.value) {
        isRadialtyre = radialTyres.includes(element.size.value);
      }
      if (isRadialtyre) {
        tubeless_tyre += element.tyres.value ? parseInt(element.tyres.value) : 0;
      } else {
        tube_tyre += element.tyres.value ? parseInt(element.tyres.value) : 0;
      }
      if (element.construction.value === 'radial') {
        radial_tyre += element.tyres.value ? parseInt(element.tyres.value) : 0;
      } else {
        bias_tyre += element.tyres.value ? parseInt(element.tyres.value) : 0;
      }
      total_tyre += element.tyres.value ? parseInt(element.tyres.value) : 0;
    });

    bias_radial_tyres[key].bias_potential_average_per_month = bias_tyre;
    bias_radial_tyres[key].radial_potential_average_per_month = radial_tyre;
    bias_radial_tyres[key].no_of_tube_tyre = tube_tyre;
    bias_radial_tyres[key].no_of_tubeless_tyre = tubeless_tyre;
    this.setState({
      bias_radial_tyres
    })

  }

  getBrand = (construction, index, key) => {
    const { controls } = this.state;
    const { frontRearData 
      // , rearData
     } = controls;
    let tyreObj = frontRearData[key][index];
    this.setState({ isLoading: true });
    FleetService.getBrand({ construction: construction })
      .then(res => {
        tyreObj.brands = res.data.data.brand;
        this.setState({
          controls,
          isLoading: false
        })
      })
      .catch(e => {
        let err = e.response && e.response.data && e.response.data.error[0] ? e.response.data.error[0] : null;
        const message = err && err.message ? err.message : '';
        ModalService.openAlert('', message, 'error');
        this.setState({ isLoading: false });
      });
  }

  changeFrontBrand = (construction, brand, index, key) => {
    const { controls } = this.state;
    const { frontRearData } = controls;
    let tyreObj = frontRearData[key][index];
    this.setState({ isLoading: true });
    FleetService.getBrandPattern({ brand_name: brand, construction: construction })
      .then(res => {
        tyreObj.pattern = res.data.data.pattern;
        this.setState({
          controls,
          isLoading: false
        })
      })
      .catch(e => {
        this.setState({ isLoading: false });
      });
  }

  setFleetDetail = (business_related_detail_data) => {
    let truck = business_related_detail_data.filter(x => x.type_name === 'truck');
    if (truck.length > 0) {
      if (truck[0].tyre_potential_data && truck[0].tyre_potential_data.all_vehicle_pontential_yearly_tyre) {
        this.setState({
          all_vehicle_total_tyre_year_truck: truck[0].tyre_potential_data.all_vehicle_pontential_yearly_tyre,
        });
      }
    }
    let bus = business_related_detail_data.filter(x => x.type_name === 'bus');
    if (bus.length > 0) {
      if (bus[0].tyre_potential_data && bus[0].tyre_potential_data.all_vehicle_pontential_yearly_tyre) {
        this.setState({
          all_vehicle_total_tyre_year_bus: bus[0].tyre_potential_data.all_vehicle_pontential_yearly_tyre,
        });
      }
    }
    this.setFrontRearData(business_related_detail_data);
    // business_related_detail_data.forEach(element => {
    //   this.setFrontRearData(element.type_name, business_related_detail_data);
    // });
    // if (business_related_detail && Object.keys(business_related_detail).length > 0) {
    //   if (business_related_detail && Object.keys(business_related_detail).length > 0) {
    // if (business_related_detail_data.truck && business_related_detail_data.truck.length > 0) {
    //   this.setFrontRearData('truck', business_related_detail_data);
    // }
    //     if (business_related_detail.bus && business_related_detail.bus.length > 0) {
    //       this.setFrontRearData('bus', business_related_detail);
    //     }
    //     if (business_related_detail.lcv && business_related_detail.lcv.length > 0) {
    //       this.setFrontRearData('lcv', business_related_detail);
    //     }
    //     if (business_related_detail.scv && business_related_detail.scv.length > 0) {
    //       this.setFrontRearData('scv', business_related_detail);
    //     }
    //     if (business_related_detail.icv && business_related_detail.icv.length > 0) {
    //       this.setFrontRearData('icv', business_related_detail);
    //     }
    //     if (business_related_detail.pickup && business_related_detail.pickup.length > 0) {
    //       this.setFrontRearData('pickup', business_related_detail);
    //     }
    //   }
    // }

  }

  checkAllDataValidationFront = () => {

    let { vehicleData } = this.state;
    let frontTruck = true, frontBus = true, frontLCV = true, frontSCV = true, frontICV = true,
      frontPickup = true;
    if (Object.keys(vehicleData).length > 0) {
      if (vehicleData.totalCountTruck > 0) {
        if (!this.handleValidationFrontData('truck', true)) {
          frontTruck = false;
        }
      }
      if (vehicleData.totalCountBus > 0) {
        if (!this.handleValidationFrontData('bus', true)) {
          frontBus = false;
        }
      }
      if (vehicleData.totalCountLcv > 0) {
        if (!this.handleValidationFrontData('lcv', true)) {
          frontLCV = false;
        }
      }
      if (vehicleData.totalCountScv > 0) {
        if (!this.handleValidationFrontData('scv', true)) {
          frontSCV = false;
        }
      }
      if (vehicleData.totalCountIcv > 0) {

        if (!this.handleValidationFrontData('icv', true)) {
          frontICV = false;
        }
      }
      if (vehicleData.totalCountPickup > 0) {
        if (!this.handleValidationFrontData('pickup', true)) {
          frontPickup = false;
        }
      }
    }

    return !!(frontTruck === true && frontBus === true && frontSCV === true && frontLCV === true &&
      frontPickup === true && frontICV === true);
  }

  handleValidationFrontData = (key = '', isSubmit = false) => {
    let { controls } = this.state;
    const { frontRearData } = controls;
    for (let i = 0; i < frontRearData[key].length; i++) {
      const currentData = frontRearData[key][i];
      if (currentData.construction.touched === true || isSubmit) {
        currentData.construction = Validation.notNullValidator(currentData.construction);
        currentData.construction.valid = !!currentData.construction.value;
      }

      if (currentData.size.touched === true || isSubmit) {
        currentData.size = Validation.notNullValidator(currentData.size);
        currentData.size.valid = !!currentData.size.value;
      }

      if (currentData.brand.touched === true || isSubmit) {
        currentData.brand = Validation.notNullValidator(currentData.brand);
        currentData.brand.valid = !!currentData.brand.value;
      }

      if (currentData.pattren.touched === true || isSubmit) {
        currentData.pattren = Validation.notNullValidator(currentData.pattren);
        currentData.pattren.valid = !!currentData.pattren.value;
      }

      if (currentData.type.touched === true || isSubmit) {
        currentData.type = Validation.notNullValidator(currentData.type);
        currentData.type.valid = !!currentData.type.value;
      }
      if (currentData.tyres.touched === true || isSubmit) {
        currentData.tyres = Validation.notNullValidator(currentData.tyres);
        currentData.tyres.valid = !!currentData.tyres.value;
      }

    }
    let isTyreDetailValid = true;
    for (let i = 0; i < frontRearData[key].length; i++) {
      const currentData = frontRearData[key][i];
      isTyreDetailValid = isTyreDetailValid && (currentData.construction.valid && currentData.size.valid && currentData.brand.valid &&
        currentData.pattren.valid && currentData.type.valid && currentData.tyres.valid)
    }
    let isValidForm = false;
    if (isTyreDetailValid) {
      isValidForm = true;
    } else {
      isValidForm = false;
    }
    this.setState({ controls });
    return isValidForm;
  }

  render() {
    let { vehicleData, frontRearData, invalidCountError } = this.state;
    let { bias_radial_tyres } = this.state.controls;
    return (
      <div>
        {this.state.isLoading && <CustomSpinner />}
        {
          (Object.keys(vehicleData).length > 0) &&
          Object.keys(frontRearData).map((key, keyIndex) => (
            ((key === 'truck' && vehicleData.totalCountTruck > 0) ||
              (key === 'bus' && vehicleData.totalCountBus > 0) ||
              (key === 'lcv' && vehicleData.totalCountLcv > 0) ||
              (key === 'scv' && vehicleData.totalCountScv > 0) ||
              (key === 'icv' && vehicleData.totalCountIcv > 0) ||
              (key === 'pickup' && vehicleData.totalCountPickup > 0)) &&
            <Card className={keyIndex === 0 ? 'mt-0' : 'mt-4'} >
              <CardBody>

                <Row>
                  <Col xl="12" md="12" xs="12">
                    <b className="margin-right-16 text-uppercase">{key} TYRES RELATED DETAILS&nbsp;<span className="required-field">*</span></b>
                  </Col>
                  {
                    ((key === 'truck' && this.state.all_vehicle_total_tyre_year_truck) || (key === 'bus' && this.state.all_vehicle_total_tyre_year_bus)) ?
                      <span className="note-rect" style={{ border: 'none', marginLeft: '15px', marginTop: '3px', padding: '0' }}>Basis on last 12 months buying practice the potential tyre count is {key === 'truck' ? this.state.all_vehicle_total_tyre_year_truck : this.state.all_vehicle_total_tyre_year_bus}</span>
                      : <span className="note-rect" style={{ border: 'none', marginLeft: '15px', marginTop: '3px', padding: '0' }}>Basis on last 12 months buying practice</span>
                  }

                </Row>

                <hr style={{ border: 'solid 1px #ced4da' }} />
                <Row style={{ justifyContent: 'space-between', paddingLeft: '15px', paddingRight: '15px' }}>
                  <Col style={{ border: '1px solid lightgrey', padding: 0, marginRight: '5px', paddingLeft: '5px', paddingTop: '10px' }} className="d-flex-row bias-radial-count-vehicle justify-content-center">
                    <Row style={{ width: '100%' }}>
                      <Col xl="6" md="12" xs="12">
                        <FormGroup className="input-same-height">
                          <Label for="company_name" className="font-weight-bold">Bias Potential Avg Per Year</Label>
                          <Input
                            type="text"
                            autocomplete="nofill"
                            disabled={true}
                            name="bias_potential_average_per_month"
                            value={bias_radial_tyres[key].bias_potential_average_per_month ? bias_radial_tyres[key].bias_potential_average_per_month : 0}
                            placeholder=" " />
                        </FormGroup>
                      </Col>

                      <Col xl="6" md="12" xs="12">
                        <FormGroup className="input-same-height">
                          <Label for="company_name" className="font-weight-bold">Radial Potential Avg Per Year</Label>
                          <Input
                            type="text"
                            autocomplete="nofill"
                            disabled={true}
                            name="bias_potential_average_per_month"
                            value={bias_radial_tyres[key].radial_potential_average_per_month ? bias_radial_tyres[key].radial_potential_average_per_month : 0}
                            placeholder=" " />
                        </FormGroup>
                      </Col>
                    </Row>
                  </Col>
                  <Col style={{ border: '1px solid lightgrey', padding: 0, paddingLeft: '5px', paddingTop: '10px' }} className="d-flex-row bias-radial-count-vehicle justify-content-center">
                    <Row style={{ width: '100%' }}>
                      <Col xl="6" md="12" xs="12">
                        <FormGroup className="input-same-height">
                          <Label for="company_name" className="font-weight-bold">No Of Tube Tyre</Label>
                          <Input
                            type="text"
                            autocomplete="nofill"
                            disabled={true}
                            name="bias_potential_average_per_month"
                            value={bias_radial_tyres[key].no_of_tube_tyre ? bias_radial_tyres[key].no_of_tube_tyre : 0}
                            placeholder=" " />
                        </FormGroup>
                      </Col>
                      <Col xl="6" md="12" xs="12">
                        <FormGroup className="input-same-height">
                          <Label for="company_name" className="font-weight-bold">No Of Tubeless Tyre</Label>
                          <Input
                            type="text"
                            autocomplete="nofill"
                            disabled={true}
                            name="bias_potential_average_per_month"
                            value={bias_radial_tyres[key].no_of_tubeless_tyre ? bias_radial_tyres[key].no_of_tubeless_tyre : 0}
                            placeholder=" " />
                        </FormGroup>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Table className="mb-0 table-responsive mt-3" bordered>
                  <thead>
                    <tr style={{ backgroundColor: '#f6f6f6' }}>
                      <th style={{ border: '1px solid #e9ecef' }}>Construction</th>
                      <th style={{ border: '1px solid #e9ecef' }}>Brand</th>
                      <th style={{ border: '1px solid #e9ecef' }}>Tyre Size</th>
                      <th style={{ border: '1px solid #e9ecef' }}>Pattren</th>
                      <th style={{ border: '1px solid #e9ecef' }}>Type</th>
                      <th style={{ border: '1px solid #e9ecef', width: '100px' }}>No of Tyres Per Year</th>
                      <th style={{ border: '1px solid #e9ecef' }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      frontRearData[key].map((item, index) => (
                        <tr>
                          <td className="business-related-detail-td form-group" valign="top">
                            <select className="form-control min-width-100px" name="construction"
                              value={item.construction.value} onChange={(e) => this.onChangeFrontTyre(e, index, key)}>
                              <option value="" selected disabled>Select</option>
                              <option value="bias">Bias</option>
                              <option value="radial">Radial</option>
                            </select>
                            {item.construction.nullValue && <div className="error mt-1 font-weight-normal">Please select construction</div>}
                          </td>
                          <td className="business-related-detail-td form-group">
                            <select className="form-control min-width-120px" name="brand" style={{ textTransform: 'capitalize' }}
                              value={item.brand.value ? item.brand.value.toLowerCase() : ''} onChange={(e) => this.onChangeFrontTyre(e, index, key, item.brands)}>
                              <option value="" selected disabled>Select</option>
                              {
                                item.brands.map((brand, j) => (
                                  <option className="text-capitalize" value={brand.name ? brand.name.toLowerCase() : ''}>{brand.name}</option>
                                ))
                              }
                              <option value="other">Other</option>
                            </select>
                            {item.brand.nullValue && <div className="error mt-1 font-weight-normal">Please select brand</div>}
                          </td>

                          <td className="business-related-detail-td form-group" valign="top">
                            <select className="form-control min-width-120px" name="size"
                              value={item.size.value} onChange={(e) => this.onChangeFrontTyre(e, index, key)}>
                              <option value="" selected disabled>Select</option>
                              {
                                (key !== 'lcv' && key !== 'scv' &&
                                  key !== 'icv' && key !== 'pickup') ?
                                  item.construction.value &&
                                  <>
                                    {
                                      item.construction.value === 'bias' ?
                                        this.state.tbbTyreSize.map((tbb, j) => (
                                          <option className="text-capitalize" value={tbb}>{tbb}</option>
                                        )) :
                                        this.state.tbrTyreSize.map((tbr, j) => (
                                          <option className="text-capitalize" value={tbr}>{tbr}</option>
                                        ))
                                    }
                                  </> :
                                  <>
                                    {
                                      item.construction.value === 'bias' ?
                                        this.state.tbbLcvScv.map((tbb, j) => (
                                          <option className="text-capitalize" value={tbb}>{tbb}</option>
                                        )) :
                                        this.state.tbrLcvScv.map((tbr, j) => (
                                          <option className="text-capitalize" value={tbr}>{tbr}</option>
                                        ))
                                    }
                                  </>
                              }
                              <option value="other">Other</option>
                            </select>
                            {item.size.nullValue && <div className="error mt-1 font-weight-normal">Please select tyre size</div>}
                          </td>

                          <td className="business-related-detail-td form-group">
                            <select className="form-control min-width-120px" name="pattren" value={item.pattren.value}
                              onChange={(e) => this.onChangeFrontTyre(e, index, key)}>
                              <option value="" selected disabled>Select</option>
                              {
                                (key !== 'lcv' && key !== 'scv' && key !== 'icv' && key !== 'pickup') ?
                                  <>
                                    {
                                      item.pattern.map((pattern, j) => (
                                        <option className="text-capitalize" value={pattern.name}>{pattern.name}</option>
                                      ))
                                    }
                                  </> : ''
                              }
                              <option value="Other">Other</option>
                            </select>
                            {item.pattren.nullValue && <div className="error mt-1 font-weight-normal">Please select pattren</div>}
                          </td>
                          <td className="business-related-detail-td form-group">
                            <select className="form-control min-width-100px" name="type"
                              value={item.type.value} onChange={(e) => this.onChangeFrontTyre(e, index, key)}>
                              <option value="" selected disabled>Select</option>
                              <option value="Direct">Direct</option>
                              <option value="Indirect">Indirect</option>
                              <option value="Mobility">Mobility</option>
                            </select>
                            {item.type.nullValue && <div className="error mt-1 font-weight-normal">Please select type.</div>}
                          </td>
                          <td className="business-related-detail-td">
                            <Input
                              type="text"
                              autocomplete="nofill"
                              name="tyres"
                              value={item.tyres.value}
                              onChange={(e) => this.onChangeFrontTyre(e, index, key)}
                              placeholder=" " />
                            {item.tyres.nullValue && <div className="error mt-1 font-weight-normal">Please enter tyres count.</div>}
                          </td>
                          <td>
                            <img className="cursor-pointer" onClick={() => this.removeFrontTyre(index, key)} src="images/delete.svg" alt='delete' /></td>
                        </tr>
                      ))
                    }
                  </tbody>
                </Table>
                <div className="d-flex mt-2">
                  <img className="cursor-pointer" src="images/add.svg" style={{ height: '18px' }} onClick={() => this.addFrontTyreObject(key)} alt='add' />&nbsp;&nbsp;
                      <span className="subsidiaries-name cursor-pointer" onClick={() => this.addFrontTyreObject(key)}>Add More</span>
                </div>
                {invalidCountError.truck.isInValid && key === 'truck' ? <span className="error">{invalidCountError.truck.message}</span> : ''}
                {invalidCountError.bus.isInValid && key === 'bus' ? <span className="error">{invalidCountError.bus.message}</span> : ''}
                {invalidCountError.lcv.isInValid && key === 'lcv' ? <span className="error">{invalidCountError.lcv.message}</span> : ''}
                {invalidCountError.icv.isInValid && key === 'icv' ? <span className="error">{invalidCountError.icv.message}</span> : ''}
                {invalidCountError.scv.isInValid && key === 'scv' ? <span className="error">{invalidCountError.scv.message}</span> : ''}
                {invalidCountError.pickup.isInValid && key === 'pickup' ? <span className="error">{invalidCountError.pickup.message}</span> : ''}
              </CardBody>
            </Card>
          ))

        }
      </div>
    );
  }
}

export default VehicleDetail;